import { lazy } from "react";

export default lazy(() => import(/* webpackChunkName: "modal-skeleton" */ "./modal-skeleton"));
